var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaggingBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9499 2.05012C10.6277 0.728 8.86987 0 7 0C5.13013 0 3.37225 0.728 2.05012 2.05012C0.728 3.37225 0 5.13013 0 7C0 8.86987 0.728 10.6277 2.05012 11.9499C3.37225 13.272 5.13013 14 7 14C8.86987 14 10.6277 13.272 11.9499 11.9499C13.272 10.6277 14 8.86987 14 7C14 5.13013 13.272 3.37225 11.9499 2.05012ZM12.25 7C12.2512 8.09015 11.9113 9.15335 11.2779 10.0406L3.95938 2.72213C4.84665 2.08875 5.90985 1.74883 7 1.75C9.8945 1.75 12.25 4.1055 12.25 7ZM1.75 7C1.74883 5.90985 2.08875 4.84665 2.72213 3.95938L10.0406 11.2779C9.15335 11.9113 8.09015 12.2512 7 12.25C4.1055 12.25 1.75 9.8945 1.75 7Z",
    fill: "#F40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggingBlocked);
export default __webpack_public_path__ + "static/media/tagging_blocked.fd925bfdde3aaf738830e114dbaede3d.svg";
export { ForwardRef as ReactComponent };